<template>
  <transition name="router-anim">
    <div class="kits">
      <div v-if="isResearch2" class="research2-filter-summary">
        <div class="summary-left">
          <button type="button" class="back-map-btn" @click="$emit('back-to-map')">
            ← Back to Map Overview
          </button>
          <span class="summary-title">View Filtered Map Records</span>
          <span class="records-count-badge">{{ effectiveList.length }} Kit(s) Found</span>
        </div>
        <div class="active-tags-list" v-if="hasActiveFilters">
          <span v-if="selectedRiskFilter" class="filter-tag risk-tag" :style="{ backgroundColor: getRiskFilterColor(selectedRiskFilter) }">
            Risk: {{ getRiskFilterLabel(selectedRiskFilter) }}
          </span>
          <span v-if="activeFilters.musty_damp_odor !== 'Any'" class="filter-tag">
            ● Musty Odor: {{ activeFilters.musty_damp_odor }}
          </span>
          <span v-if="activeFilters.visible_mold !== 'Any'" class="filter-tag">
            ■ Visible Mold: {{ activeFilters.visible_mold }}
          </span>
          <span v-if="activeFilters.symptoms !== 'Any'" class="filter-tag">
            ▲ Symptoms: {{ activeFilters.symptoms }}
          </span>
        </div>
      </div>
      <div class="kits-title">
        <div class="title id">
          KIT ID
        </div>
        <div class="title status">
          STATUS
        </div>
        <div class="title first-name">
          FIRST NAME
        </div>
        <div class="title last-name">
          LAST NAME
        </div>
        <div class="title email">
          EMAIL
        </div>
        <div class="title phone">
          PHONE
        </div>
         <div class="title result" @click="sortedByResult">
          REPORT RESULT
           <img
            src="../../../images/dashboard/up.png"
            alt="#"
            v-if="sortedByStateResult === 'desc'"
          />
          <img
            class="down"
            src="../../../images/dashboard/down.png"
            alt="#"
            v-else
          />
        </div>
        <div class="title date" @click="sortedBy">
          ACTIVATED DATE
          <img
            src="../../../images/dashboard/up.png"
            alt="#"
            v-if="sortedByState === 'desc'"
          />
          <img
            class="down"
            src="../../../images/dashboard/down.png"
            alt="#"
            v-else
          />
        </div>
      </div>
      <div v-if="paginatedAnalytics.length > 0">
        <div class="kits-item" v-for="(item, index) in paginatedAnalytics" :key="index">
          <div class="kit-desc id"
          @click.stop="stopPropagation"
            @click="showModal(item.id, item.user_id, 'kit')"
          >
            {{ convertKitId(item.kit_id) }}
          </div>
          <div
            class="kit-desc status"
            :style="
              item.status === 'on_hold' ? { color: 'rgb(232, 122, 1)' } : null
            "
          >
            <span class="onHoldStatus" v-if="item.status === 'on_hold'">
              On Hold
              <button
                @click.stop="stopPropagation"
                @click="showModal(item.id, item.user_id, 'hold')"
                class="onhold-btn"
              >
                <img
                  class="onhold-btn-img"
                  src="../../../images/dashboard/onhold.png"
                  alt="#"
                />
              </button>
            </span>
            <span v-if="item.status === 'analysis_completed'"
              >Analysis Complete</span
            >
            <span v-if="item.status === 'analysis_failed'">Analysis Failed</span>
            <span v-if="item.status === 'partially_failed'"
              >Analysis Partially Complete</span
            >
            <span v-if="item.status === 'lab_received'">Lab Received</span>
            <span v-if="item.status === 'lab_awaiting'">Submitted</span>
            <span v-if="item.status === 'shipped'">Shipped</span>
            <span v-if="item.status === 'activated'">Activated</span>
            <span v-if="item.status === 'delivered'">Delivered</span>
            <div
              class="status-line"
              :style="
                item.status === 'on_hold'
                  ? { backgroundColor: 'rgba(232, 122, 1, .4)' }
                  : null
              "
            >
              <div
                class="status-line-bg"
                :style="[
                  item.status === 'shipped' ? { width: '16.6%' } : null,
                  item.status === 'delivered' ? { width: '28.8%' } : null,
                  item.status === 'activated' ? { width: '49.8%' } : null,
                  item.status === 'lab_awaiting' ? { width: '66.4%' } : null,
                  item.status === 'lab_received' ? { width: '83%' } : null,
                  item.status === 'on_hold'
                    ? { width: '83%', backgroundColor: '#E87A01' }
                    : null,
                  item.status === 'analysis_failed'
                    ? { width: '100%', backgroundColor: 'red' }
                    : null,
                  item.status === 'partially_failed'
                    ? { width: '100%', backgroundColor: 'grey' }
                    : null,
                  item.status === 'analysis_completed' ? { width: '100%' } : null
                ]"
              ></div>
            </div>
          </div>
          <div class="kit-desc first-name" v-if="item.collected_first_name">
            <span>{{ item.collected_first_name }}</span>
          </div>
          <div class="kit-desc first-name" v-else>
            <span v-if="item.user">{{ item.user.first_name }}</span>
          </div>
          <div class="kit-desc last-name" v-if="item.collected_last_name">
            <span>{{ item.collected_last_name }}</span>
          </div>
          <div class="kit-desc last-name" v-else>
            <span v-if="item.user">{{ item.user.last_name }}</span>
          </div>
          <div class="kit-desc email" v-if="item.collected_email">
            <span>{{ item.collected_email }}</span>
          </div>
          <div class="kit-desc email" v-else>
            <span v-if="item.user">{{ item.user.email }}</span>
          </div>
          <div class="kit-desc phone">
            <span v-if="item.user">{{ makePhone(item.user.phone) }}</span>
          </div>
          <div class="kit-desc result">
            <div v-if="item.status === 'analysis_completed' || item.status === 'completed' || item.status === 5 || item.status === '5'">
              <span
                class="status green"
                v-if="
                  item.result === 0"
                >Not Evident</span
              >
              <span
                class="status yellow"
                v-if="
                item.result === 1"
                >Slightly Evident</span
              >
              <span
                class="status orange"
                v-if="item.result === 2"
                >Moderately Evident</span
              >
              <span
                class="status red"
                v-if=" item.result === 3"
                >Significantly Evident</span
              >
            </div>
            <div v-else >
              <span>N/A</span>
            </div>
          </div>
          <div class="kit-desc date">
            {{ date(item.activated_at) }}
          </div>
        </div>
        <div class="pogination">
          <Paginate
            v-if="count_page > 1"
            :page-count="count_page"
            :page-class="'pogination-item'"
            :click-handler="changePage"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pogination-wrap'"
          ></Paginate>
        </div>
      </div>
      <div v-else class="kits-item">
          <div class="kit-desc nodata">
            No Data Retrieved.
          </div>
      </div>
    </div>
  </transition>
</template>

<script>
import moment from "moment";
import { mapGetters , mapActions} from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
import Paginate from "vuejs-paginate";

export default {
  name: "AnalyticsList",
  mixins: [parseAndConvertKitId],
  props: {
    isResearch2: {
      type: Boolean,
      default: false
    },
    filteredKits: {
      type: Array,
      default: () => []
    },
    selectedRiskFilter: {
      type: String,
      default: null
    },
    activeFilters: {
      type: Object,
      default: () => ({ musty_damp_odor: "Any", visible_mold: "Any", symptoms: "Any" })
    }
  },
  data() {
    return {
      analytics: {},
      count_page: 1,
      perPage: 10,
      params: null,
      sortedByState: "desc",
      sortedByStateResult: "desc"
    };
  },
  components: {
    Paginate
  },
  computed: {
    ...mapGetters(["getAnalyticsList", "getAnalyticsParams", "adminPogination"]),
    effectiveList() {
      if (this.isResearch2) {
        let list = [...(this.filteredKits || [])];
        if (this.sortedByState) {
          list.sort((a, b) => {
            const dateA = new Date(a.activated_at || 0).getTime();
            const dateB = new Date(b.activated_at || 0).getTime();
            return this.sortedByState === "asc" ? dateA - dateB : dateB - dateA;
          });
        }
        return list;
      }
      return Array.isArray(this.analytics) ? this.analytics : (this.analytics.data || []);
    },
    paginatedAnalytics() {
      if (!this.isResearch2) {
        return Array.isArray(this.analytics) ? this.analytics : (this.analytics.data || []);
      }
      const start = (this.count_page - 1) * this.perPage;
      const end = start + this.perPage;
      return this.effectiveList.slice(start, end);
    },
    totalPages() {
      if (!this.isResearch2) {
        return this.$store.getters.adminPogination || 1;
      }
      return Math.ceil(this.effectiveList.length / this.perPage) || 1;
    },
    hasActiveFilters() {
      if (!this.isResearch2) return false;
      return (
        !!this.selectedRiskFilter ||
        (this.activeFilters && (
          this.activeFilters.musty_damp_odor !== "Any" ||
          this.activeFilters.visible_mold !== "Any" ||
          this.activeFilters.symptoms !== "Any"
        ))
      );
    }
  },
  methods: {
    ...mapActions([
      "setAdminPginationPage",
      "getAnalyticsInfoList",
      "setSortedByAdmin",
      "setSortedBy",
      "testKitInfo",
      "getUserInfo"
    ]),
    getRiskFilterLabel(key) {
      const labels = {
        green: "Not Evident",
        yellow: "Slightly Evident",
        orange: "Moderately Evident",
        red: "Significantly Evident",
        grey: "Problematic"
      };
      return labels[key] || key;
    },
    getRiskFilterColor(key) {
      const colors = {
        green: "#5cb85c",
        yellow: "#f1c40f",
        orange: "#ff9800",
        red: "#f53b57",
        grey: "#808080"
      };
      return colors[key] || "#005eb8";
    },
    changePage(item) {
      if (this.isResearch2) {
        this.count_page = item;
        return;
      }
      this.setAdminPginationPage(item).then(() => {
        this.getAnalyticsInfoList(this.params);
      });
    },
    sortedBy() {
      if (this.sortedByState === "desc") {
        this.sortedByState = "asc";
      } else {
        this.sortedByState = "desc";
      }
      if (!this.isResearch2) {
        this.setSortedByAdmin(this.sortedByState).then(() => {
          this.getAnalyticsInfoList(this.params);
        });
      }
    },
    sortedByResult() {
      if (this.sortedByStateResult === "desc") {
        this.sortedByStateResult = "asc";
      } else {
        this.sortedByStateResult = "desc";
      }
      if (!this.isResearch2) {
        this.setSortedBy(this.sortedByStateResult).then(() => {
          this.getAnalyticsInfoList(this.params);
        });
      }
    },
    date(localDate) {
      if (localDate !== null && localDate !== undefined) {
        let date = new Date(localDate);
        return moment(date).format("MM/DD/YYYY");
      }
      return "N/A";
    },
    makePhone(phone) {
      if (phone === null || phone === undefined) {
        return null;
      }
      const cleanPhone = String(phone).replace(/\D/g, "");
      if (cleanPhone.length === 11 || cleanPhone.length === 10) {
        const phoneArr = cleanPhone.split("");
        if (cleanPhone.length === 11) {
          return `(${phoneArr[1]}${phoneArr[2]}${phoneArr[3]}) ${phoneArr[4]}${phoneArr[5]}${phoneArr[6]}-${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}${phoneArr[10]}`;
        } else if (cleanPhone.length === 10) {
          return `(${phoneArr[0]}${phoneArr[1]}${phoneArr[2]}) ${phoneArr[3]}${phoneArr[4]}${phoneArr[5]}-${phoneArr[6]}${phoneArr[7]}${phoneArr[8]}${phoneArr[9]}`;
        }
      }
      return null;
    },
    showModal(kitId, userId, modal) {
      this.testKitInfo(kitId).then(res => {
        if (modal === "kit") {
          if (userId !== null) {
            this.getUserInfo(userId).then(res => {
              this.$emit("showModal", true);
            });
          } else {
            this.$emit("showModal", true);
          }
        } else if (modal === "hold") {
          this.$emit("showComment", {
            txt: this.$store.getters.getTestKitInfo.reason_on_hold,
            show: true,
            id: this.$store.getters.getTestKitInfo.id
          });
        }
      });
    },
    openAnalytics(first_name, last_name, email, id) {
      this.$emit("showAnalyticsInfo", {
        first_name,
        last_name,
        id,
        email,
        show: true
      });
    },
    stopPropagation(event) {
      event.stopPropagation();
    }
  },
  watch: {
    adminPogination(num) {
      if (!this.isResearch2) {
        this.count_page = num;
      }
    },
    getAnalyticsList(obj) {
      this.analytics = obj;
    },
    getAnalyticsParams(obj) {
      this.params = obj;
    }
  },
  mounted() {
    this.analytics = this.$store.getters.getAnalyticsList;
    this.params = this.$store.getters.getAnalyticsParams;
    if (!this.isResearch2 && this.$store.getters.adminPogination !== null) {
      this.count_page = this.$store.getters.adminPogination;
    }
  }
};
</script>
<style scoped lang="scss">
.research2-filter-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #ffffff;
  padding: 12px 20px;
  border-radius: 10px;
  margin-bottom: 16px;
  border: 1px solid #cbd5e1;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.summary-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-map-btn {
  background: #005eb8;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.back-map-btn:hover {
  background: #004494;
}

.summary-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.records-count-badge {
  background: #e2e8f0;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 12px;
}

.active-tags-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.filter-tag {
  background: #f1f5f9;
  color: #334155;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
}

.risk-tag {
  color: #ffffff !important;
  border: none;
}

.kits {
  margin: 20px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 20px 0;
  padding: 0 30px;
}
.title {
  color: #b3b3b3;
  font-size: 12px;
  font-family: TTNormsMedium, sans-serif;
}
.kit-desc.id {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
  cursor: pointer;
  transition: all 0.5s linear;
}
.kit-desc.id:hover {
  color: #005eb8;
  font-family: TTNormsRegular, sans-serif;
}
.title.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
}
.kit-desc.status {
  min-width: 170px;
  width: 100%;
  max-width: 170px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.kit-desc.status span {
  width: 100%;
  max-width: 170px;
  overflow: hidden;
}
.title.id {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
}
.title.first-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.first-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.last-name {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.last-name {
   min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.email {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.email {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
  overflow: hidden;
  padding: 0 5px 0 0;
}
.kit-desc.email span {
  width: 100%;
  max-width: 150px;
  overflow: hidden;
  display: inline-block;
}
span{
  color: #58595b;
}
.kit-desc.first-name span,
.kit-desc.last-name span {
  width: 100%;
  max-width: 140px;
  overflow: hidden;
  display: inline-block;
}
.title.phone {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
}
.kit-desc.phone {
  min-width: 130px;
  width: 100%;
  max-width: 130px;
}
.title.result {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.kit-desc.result {
  min-width: 150px;
  width: 100%;
  max-width: 150px;
}
.title.result img {
  max-width: 7px;
  height: 14px;
margin-left: 17px;
}
.title.result .down {
  transform: rotate(180deg);
}
.title.date {
  min-width: 150px;
  width: 100%;
  position: relative;
  cursor: pointer;
}
.title.date img {
  max-width: 7px;
  height: 14px;
  position: absolute;
  top: -3px;
  right: 25px;
}
.title.date .down {
  transform: rotate(180deg);
}
.kit-desc.date {
  min-width: 150px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  padding: 25px 30px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kits-item:hover .remove-kit-btn {
  display: block;
}
.kit-desc {
  color: #58595b;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.status {
  color: #cccdcf;
}
.status.green {
  color: green;
}
.status.red {
  color: red;
}
.status.orange {
  color: orange;
}
.status.purple {
  color: #ac75bd;
}
.status.yellow {
  color: gold;
}
.pogination {
  margin: 20px 0 0 0;
}
.status-line {
  width: 100%;
  max-width: 140px;
  height: 3px;
  background-color: rgba(0, 70, 173, 0.3);
  margin: 5px 0 0 0;
  position: relative;
}
.status-line-bg {
  position: absolute;
  width: 50%;
  content: "";
  left: 0;
  top: 0;
  height: 100%;
  background-color: #005eb8;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  padding: 0;
}
.onhold-btn {
  background-color: transparent;
  border: none;
  padding: 0;
  max-width: 15px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  margin: 0 0 0 5px;
  cursor: pointer;
}
.onhold-btn-img {
  max-width: 100%;
}
.onHoldStatus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.remove-kit-btn {
  display: none;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #58595b;
  border-radius: 5px;
  right: 20px;
  cursor: pointer;
  &:before,
  &:after {
    content: "";
    display: block;
    position: absolute;
    height: 1px;
    width: 13px;
    background-color: #58595b;
    top: 50%;
    left: 50%;
    transform: translate(-50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%) rotate(-45deg);
  }
  &:hover {
    border-color: red;
    &:before,
    &:after {
      background-color: red;
    }
  }
}
@media print {
  .kits {
    display: none;
  }
}
.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
</style>
}
</style>
